import styled from 'styled-components/native';

export const Container = styled.TouchableOpacity`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 6px;
	border-radius: 8px;
`;
